import { mapState } from 'vuex'

export default {
  data () {
    return {
      detailBadgeId: null,
      showDetails: false
    }
  },
  computed: {
    ...mapState(['content', 'badges', 'superBadges']),
    detail () {
      return this.content
        .reduce((prev, next) => ([...prev, ...next.links.map(l => Object.assign(l, { group: next.title }))]), [])
        .find(link => link.id === this.$route.params.contentId)
    },
    badgesGrouped () {
      const badgesContent = [...this.badges, ...this.superBadges].sort((a, b) => a.title.localeCompare(b.title))
      return [
        { title: 'Odznaki meczowe', items: badgesContent.filter(b => b.kind === 'Meczowa') },
        { title: 'Odznaki imprezowe', items: badgesContent.filter(b => b.kind === 'Impreza') },
        { title: 'Odznaki turniejowe', items: badgesContent.filter(b => b.kind === 'Turniejowa') }
      ]
    },
    badge () {
      return [...this.badges, ...this.superBadges].find(b => b.id === this.detailBadgeId)
    },
    badgeImageName () {
      if (!this.badge) return null
      return this.badge.image
    }
  }
}
